import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade, FavoritesFacade, Stop } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-add-favorite-stop',
    templateUrl: './add-favorite-stop-modal.component.html',
    styleUrls: ['./add-favorite-stop-modal.component.scss']
})
export class AddFavoriteStopModalComponent extends BaseComponent implements OnDestroy {
    @Input() stop: Stop;
    assetsPath$ = this.applicationFacade.assetsPath$;
    isContrast$ = this.applicationFacade.highContrast$;

    constructor(
        @Inject('ENV') public env: Env,
        private modalCtrl: ModalController,
        private favoritesFacade: FavoritesFacade,
        private applicationFacade: ApplicationFacade
    ) {
        super();
    }

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    async saveFavorite() {
        this.favoritesFacade.addFavoriteStop({
            ...this.stop,
            stopId: this.stop.id,
            alias: this.stop.name
        });

        await this.modalCtrl.dismiss(this.stop.name, 'confirm');
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
